module.exports = __webpack_public_path__ + "media/images/page/shop-logo-00669e3560e889a6ad2cc66def567ae0.png";